import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MetadataState } from '../../types';

const initialState: MetadataState = {
  isLoading: false,
  language: 'de',
};

const metadataSlice = createSlice({
  name: 'metadata',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setLanguage: (state, action: PayloadAction<'de' | 'en'>) => {
      state.language = action.payload;
    },
  },
});

export const { setLoading, setLanguage } = metadataSlice.actions;
export default metadataSlice.reducer;

